import script from "./PublicMembersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMembersModal.vue?vue&type=script&setup=true&lang=js"

import "./PublicMembersModal.vue?vue&type=style&index=0&id=1037afba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1037afba"]])

export default __exports__